import React, { FunctionComponent, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import IExtendedFeaturesList from '../../../../../../model/IExtendedFeaturesList';
import FeatureOption from '../FeatureOption';
import ICategoryAttributes from '../../../../../../model/ICategoryAttributes';
import featureOptionStyle from '../featureOptionStyle';
import useViewMoreElements from '../../../../../../../gqlCommon/hooks/useViewMoreElements';
import ViewMoreCta from '../../../../../../../gqlCommon/components/presentation/viewMoreCTA/ViewMoreCTA';
import customise from '../../../../../../constants/customise';
import IFeature from '../../../../../../model/IFeature';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';
import useDxpDataLayer from '../../../../../../../common/hooks/useDxpDataLayer';

export interface IFeaturesListProps {
  featuresList: IExtendedFeaturesList;
  categoryAttributes?: ICategoryAttributes;
  onClick: (id: string) => void;
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const FeatureOptionList: FunctionComponent<IFeaturesListProps> = ({
  featuresList,
  categoryAttributes,
  onClick,
  openAccessoryDetailsModal,
}) => {
  const styles = featureOptionStyle();
  const { currentIndex, incrementViewMoreCount, shouldRenderCTA } = useViewMoreElements(
    categoryAttributes.viewnumberoffeatures === customise.ALL
      ? null
      : parseInt(categoryAttributes.viewnumberoffeatures),
    featuresList.features.length,
  );
  const { optimisticSelectedFeatures } = useCustomizeCarContext();
  const { setInitialColors } = useDxpDataLayer();

  useEffect(() => {
    setInitialColors(featuresList.features, categoryAttributes);
  }, []);

  return (
    <Grid className={styles.container} container={true} data-test={`options:type:${featuresList}`}>
      {featuresList.features.map((feature, index) => {
        if (currentIndex && index >= currentIndex) {
          return null;
        }

        return (
          <FeatureOption
            key={feature.code}
            id={feature.code}
            feature={feature}
            onClick={onClick}
            isSelected={optimisticSelectedFeatures.includes(feature.code)}
            categoryAttributes={categoryAttributes}
            openAccessoryDetailsModal={openAccessoryDetailsModal}
          />
        );
      })}
      {shouldRenderCTA && <ViewMoreCta onClick={incrementViewMoreCount} />}
    </Grid>
  );
};

export default FeatureOptionList;
